<template>
    <div class="price-wrap">
        <template v-if="isComda && checkIfSpecial">
            <table :class="['price-matrix', 'price-matrix--table', 'price-matrix--special-price', customFont]">
                <tr class="price-matrix__line">
                    <template v-for="(tier, index) in store.prices.tier" :key="index">
                        <td v-if="index===0" :class="[isComda ? 'price-matrix__title_comda' : 'price-matrix__title']">Quantity</td>
                        <td :style="{'font-family': isComda ? 'Montserrat' : 'museo-sans' }">{{ tier.QtyMin }}+</td>
                    </template>
                </tr>
                <tr class="price-matrix__line">
                    <template v-for="(tier, index) in store.prices.tier" :key="index">
                        <td v-if="index===0" :class="[isComda ? 'price-matrix__title_comda' : 'price-matrix__title']">
                            <span :class="[isComda ? 'all-in-price_comda' : 'all-in-price']">
                                {{getPriceName}}
                            </span>
                        </td>
                        <td
                            :class="['price-matrix__col', 'price-matrix__col--price', customColor]"
                            :style="{
                                'font-size': (isComda ? 14 : 12) + 'px!important',
                                'font-weight': (isComda ? 800 : 700) + '!important',
                                'font-family': (isComda ? 'Montserrat' : 'museo-sans') + '!important'
                            }"
                        >
                            ${{ tier.price.toFixed(2) }}
                        </td>
                    </template>
                </tr>
                <tr class="price-matrix__line">
                    <template v-for="(tier, index) in store.prices.tier" :key="index">
                        <td v-if="index===0" :class="[isComda ? 'price-matrix__title_comda' : 'price-matrix__title']">Sale Price</td>
                        <td :class="['price-matrix__col', isComda ? 'price-matrix__col--your-save_comda' : 'price-matrix__col--your-save']">
                            <template v-if="tier['sale_price']">
                                ${{ tier['sale_price'].toFixed(2) }}
                            </template>
                        </td>
                    </template>
                </tr>
            </table>
        </template>
        <template v-if="isComda && !checkIfSpecial">
            <table :class="['price-matrix', 'price-matrix--table', customFont]">
                <tr class="price-matrix__line">
                    <template v-for="(tier, index) in store.prices.tier" :key="index">
                        <td v-if="index===0" :class="[isComda ? 'price-matrix__title_comda' : 'price-matrix__title']">Quantity</td>
                        <td :style="{'font-family': isComda ? 'Montserrat' : 'museo-sans' }">{{ tier.QtyMin }}+</td>
                    </template>
                </tr>
                <tr class="price-matrix__line">
                    <template v-for="(tier, index) in store.prices.tier" :key="index">
                        <td v-if="index===0" :class="[isComda ? 'price-matrix__title_comda' : 'price-matrix__title']">
                        <span :class="[isComda ? 'all-in-price_comda' : 'all-in-price']">
                            {{getPriceName}}
                        </span>
                        </td>
                        <td
                            :class="['price-matrix__col', 'price-matrix__col--price', customColor]"
                            :style="{
                            'font-size': (isComda ? 14 : 12) + 'px!important',
                            'font-weight': (isComda ? 800 : 700) + '!important',
                            'font-family': (isComda ? 'Montserrat' : 'museo-sans') + '!important'
                        }"
                        >
                            ${{ tier.price.toFixed(2) }}
                        </td>
                    </template>
                </tr>
                <tr class="price-matrix__line">
                    <template v-for="(tier, index) in store.prices.tier" :key="index">
                        <td v-if="index===0" :class="[isComda ? 'price-matrix__title_comda' : 'price-matrix__title']">You Save</td>
                        <td :class="['price-matrix__col', isComda ? 'price-matrix__col--your-save_comda' : 'price-matrix__col--your-save']">
                            {{ index > 0 ? Math.round(100 - ((tier.price * 100) / store.prices.tier[0].price)) + '%' : '' }}
                        </td>
                    </template>
                </tr>
            </table>
        </template>
        <template v-if="!isComda">
            <table :class="['price-matrix', 'price-matrix--table', customFont]">
                <tr class="price-matrix__line">
                    <template v-for="(tier, index) in store.prices.tier" :key="index">
                        <td v-if="index===0" :class="[isComda ? 'price-matrix__title_comda' : 'price-matrix__title']">Quantity</td>
                        <td :style="{'font-family': isComda ? 'Montserrat' : 'museo-sans' }">{{ tier.QtyMin }}+</td>
                    </template>
                </tr>
                <tr class="price-matrix__line">
                    <template v-for="(tier, index) in store.prices.tier" :key="index">
                        <td v-if="index===0" :class="[isComda ? 'price-matrix__title_comda' : 'price-matrix__title']">
                        <span :class="[isComda ? 'all-in-price_comda' : 'all-in-price']">
                            {{getPriceName}}
                        </span>
                        </td>
                        <td
                            :class="['price-matrix__col', 'price-matrix__col--price', customColor]"
                            :style="{
                            'font-size': (isComda ? 14 : 12) + 'px!important',
                            'font-weight': (isComda ? 800 : 700) + '!important',
                            'font-family': (isComda ? 'Montserrat' : 'museo-sans') + '!important'
                        }"
                        >
                            ${{ tier.price.toFixed(2) }}
                        </td>
                    </template>
                </tr>
                <tr class="price-matrix__line">
                    <template v-for="(tier, index) in store.prices.tier" :key="index">
                        <td v-if="index===0" :class="[isComda ? 'price-matrix__title_comda' : 'price-matrix__title']">You Save</td>
                        <td :class="['price-matrix__col', isComda ? 'price-matrix__col--your-save_comda' : 'price-matrix__col--your-save']">
                            {{ index > 0 ? Math.round(100 - ((tier.price * 100) / store.prices.tier[0].price)) + '%' : '' }}
                        </td>
                    </template>
                </tr>
            </table>
        </template>

        <div
            class="retail-price banner-included-section"
            v-if="isComda && store.application_type != 'calendar_single'"
        >
            <template v-if="checkIfSpecial">
                <div class="product-special-price-section">
                    <div class="is-comda-product-special" :style="`background-image: url('` + specialPriceBannerImageUrl + `')`">

                    </div>
                </div>
            </template>
            <template v-else>
                <div></div>
            </template>
            <div class="retail-price__inline retail-price__inline--special-price">
                <div class="tooltip-icon-wrap">
                     <span class="tooltip-icon"> ?</span>
                    <div :class="['tooltip-content']"
                         :style="{'font-family': (isComda ? 'Montserrat' : 'museo-sans') + '!important'}"
                    >
                        <b style="display: block; padding-bottom: 10px;">
                            Retail Value
                        </b>
                        <span>
                            The cost to buy one of these products, fully customized, at a retail store.
                        </span>
                    </div>
                </div>
                <h4 :style="{
                    'font-family': (isComda ? 'Oswald' : 'museo-sans') + '!important',
                    'font-weight': (isComda ? 'bold' : 900) + '!important',
                    'letter-spacing': 'normal!important'
                    }">
                    Retail Value:
                </h4>
                <span :class="['price-matrix__col', 'price-matrix__col--price', customColor]"
                      :style="{'font-size': (isComda ? 15 : 12) + 'px!important'}"
                >
                    {{ '$' + store.prices.tierMSRP.toFixed(2) }}
                </span>
            </div>
        </div>
        <div class="retail-price" v-if="!isComda && store.application_type != 'calendar_single'">
            <div class="tooltip-icon-wrap">
                <span class="tooltip-icon"> ?</span>
                <div :class="['tooltip-content']"
                     :style="{'font-family': (isComda ? 'Montserrat' : 'museo-sans') + '!important'}"
                >
                    <b style="display: block; padding-bottom: 10px;">
                        Retail Value
                    </b>
                    <span>
                        The cost to buy one of these products, fully customized, at a retail store.
                    </span>
                </div>
            </div>
            <h4 :style="{
                'font-family': (isComda ? 'Oswald' : 'museo-sans') + '!important',
                'font-weight': (isComda ? 'bold' : 900) + '!important',
                'letter-spacing': 'normal!important'
                }">
                Retail Value:
            </h4>
            <span :class="['price-matrix__col', 'price-matrix__col--price', customColor]"
                  :style="{'font-size': (isComda ? 15 : 12) + 'px!important'}"
            >
                {{ '$' + store.prices.tierMSRP.toFixed(2) }}
            </span>
        </div>
    </div>
</template>

<script>
import {store} from './store';
import functions from "@/helpers/functions";

export default {
    name: 'PriceMatrixComponent',
    data() {
        return {
            store: store,
            functions: functions,
            specialPriceBannerImageUrl: 'https://imprint-uploads.s3.ca-central-1.amazonaws.com/assets/images/imprint_app/baners/special-pricing.png'
        }
    },
    props: {
        applicationType: String,
        isSpecial: Boolean
    },
    computed: {
        customColor() {
            return this.$getCustomColorClass(store.storeID);
        },
        checkIfSpecial(){
            return Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku);
        },
        customFont() {
            return this.$getCustomFontClass(store.storeID);
        },
        isComda() {
            return store.storeID.includes('comda');
        },
        getPriceName() {
            let result = 'All-In price';

            if(this.isComda){
                result = this.applicationType == 'calendar_single' ? 'Our Price' : 'Price';
            }

            return result;
        }
    },
    created() {
        console.warn("is Special from pricematrix");
        console.log(Object.keys(this.store.specialPrice.byImprintMethods).includes(this.store.selectedImprint.sku));
        console.error(this.isSpecial);
        console.log("imprint Tabs data pricematrix");
        console.log(this.store.selectedImprint.tabName);
        console.log(this.store.imprintKey);
        console.log(this.store.specialPrice);
    }
}
</script>

<style>
.price-matrix--special-price .price-matrix__col--price.price-matrix__col {
    text-decoration: line-through;
    font-size: 14px;
    font-weight: 800;
    padding: 0px 0px;
    margin: 0;
    font-family: 'Montserrat', 'Helvetica Neue', Verdana, Arial, sans-serif;
}
.price-matrix--special-price .price-matrix__col.price-matrix__col--your-save_comda {
    font-weight: 800!important;
    font-size: 17px!important;
    margin: 0!important;
    color: #ca3435;
    padding: 0px 0px;
}
.retail-price__inline.retail-price__inline--special-price {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
}
.retail-price.banner-included-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.product-special-price-section {
    width: 200px;
    height: 50px;
}
.is-comda-product-special {
    width: 300px;
    height: 50px;
    background-size: contain;
    background-repeat: no-repeat;
}


.price-matrix.price-matrix--table .price-matrix__line .price-matrix__col.price-matrix__col--price,
.retail-price .price-matrix__col.price-matrix__col--price{
    font-weight: 700 !important;
    font-size: 12px;
    font-family: 'Montserrat', 'Helvetica Neue', Verdana, Arial, sans-serif !important;
}

.price-matrix.price-matrix--table .price-matrix__line .price-matrix__col.price-matrix__col--your-save {
    font-family: "museo-sans", sans-serif !important;
    font-weight: 300 !important;
    font-size: 12px;
    color: #E83223;
}

.price-matrix.price-matrix--table .price-matrix__line .price-matrix__col.price-matrix__col--your-save_comda {
    font-weight: 600 !important;
    font-family: 'Montserrat', 'Helvetica Neue', Verdana, Arial, sans-serif !important;
    font-size: 12px;
    color: #ca3435;
}

.price-matrix.price-matrix--table tr {
    background-color: #fff;
}

.price-matrix.price-matrix--table tr:nth-child(1) {
    border-top: unset !important;
    border-bottom: solid 1px black !important;
}

.price-matrix.price-matrix--table tr:nth-child(3) {
    border-bottom: unset !important;
    border-top: solid 1px black !important;
}

.price-matrix.price-matrix--table tr:nth-child(2) {
    border-bottom: solid 1px black !important;
}

.price-matrix .price-matrix__title {
    font-size: 12px;
    font-weight: 300;
    color: #5c5c5c;
    font-family: museo-sans, sans-serif;
}

.price-matrix .price-matrix__title_comda {
    font-size: 12px;
    font-weight: 400;
    color: #5c5c5c;
    font-family: Arial, sans-serif;
}

.price-matrix.price-matrix--table td {
    border-left: unset !important;
    border-right: unset !important;
}

.price-matrix:not(.price-matrix--table) .price-matrix__line {
    list-style-type: none;
    display: flex;
}

.price-matrix.price-matrix--table {
    width: 100%;
    font-size: 12px;
    margin-bottom: 15px;
}

.retail-price {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    margin: 20px 0 10px 0;
}
.retail-price h4{
    color: #000000;
    font-size: 12px;
    margin-right: 3px;
    margin-bottom: 0;
}
.tooltip-icon-wrap{
  position: relative;
}
.tooltip-icon {
    margin-right: 5px;
    display: inline-flex;
    width: 13px;
    height: 13px;
    justify-content: center;
    align-items: center;
    padding-top: 1px;
    cursor: pointer;
    font-size: 8px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    background-color: #777;
    border-radius: 50%;
    position: relative;
}

.tooltip-content {
    opacity: 0;
    position: absolute;
    left: -168px;
    top: 50%;
    transform: translate(0, -50%);
    white-space: nowrap;
    padding: 5px 10px 5px 10px;
    width: 160px;
    text-align: left;
    background-color: #000;
    color: #ffffff;
    font-size: 11px;
    font-weight: 300;
    border: none;
    border-radius: 5px;
    z-index: 1;
    bottom: -50px;
    height: fit-content;
    line-height: 1.4;
    transition: opacity 0.3s ease;

    span {
        white-space: normal;
    }
}

.tooltip-content::after {
    content: "";
    position: absolute;
    top: 44%;
    right: -9px;
    margin-left: 0;
    border-width: 5px;
    border-style: solid;
    border-color: #000 transparent transparent transparent;
    transform: rotate(-90deg);
}

.tooltip-icon:hover +.tooltip-content {
    opacity: 1;
}
.price-matrix__line span.all-in-price{
  font-family: museo-sans, sans-serif;
  color: #5c5c5c;
  font-size: 12px;
  font-weight: 800;
  line-height: 12px;
}
.price-matrix__line span.all-in-price_comda{
    font-family: 'Montserrat', Helvetica, "Helvetica Neue", Arial, sans-serif;
    color: #5c5c5c;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
}
.product-promo-section{
  text-align: left;
}

.retail-price .price-matrix__col.price-matrix__col--price{
    font-weight: 800 !important;
    font-family: 'Montserrat', 'Helvetica Neue', Verdana, Arial, sans-serif;
}

.price-wrap table:not(#customer-orders):not(#order-details) td{
    padding: 10px 0;
}


.price-wrap table td:first-child{
    padding: 10px;
}
</style>